import { DefaultError, useQuery } from '@tanstack/react-query';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IMusicProductDigitalAssetId } from './types/query';

export const useGetMusicProductDigitalAssetId = (
  DigitalMusicProductId: string
) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<IMusicProductDigitalAssetId[], DefaultError>({
    queryKey: ['mpd-assets-id', DigitalMusicProductId],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `MusicProductDigital/AssetIds`,
        params: { DigitalMusicProductId },
      });

      return responseHandler(response, {
        groupName: `useGetMusicProductDigitalAssetId`,
      });
    },
  });
};
